export type SectionId = "bio-age" | "systems" | "programming";

export type SubStep = {
  id: string;
  label: string;
};

export type Section = {
  id: SectionId;
  label: string;
  subs: SubStep[];
};

export const SECTIONS: Section[] = [
  {
    // Section 1 — 4 sub-steps with progressive disclosure (each adds a panel
    // to the previous). The intro splash (AI Guided / Self Guided choice)
    // lives OUTSIDE the stepper logic — see ConsultationContext.
    id: "bio-age",
    label: "PNOĒ Age",
    subs: [
      { id: "clock", label: "Bio Age" },
      { id: "comparison", label: "Bio Age vs Chronological" },
      { id: "younger", label: "Making you younger" },
      { id: "older", label: "Full breakdown" },
    ],
  },
  {
    // Section 2 — one sub-step per system in the sidebar (no separate
    // "overview"). Order matches the Figma sidebar (node 14711:148285).
    // `body-composition` is filtered at render time when no InBody data
    // (see useAvailableSections + SystemsSidebar).
    id: "systems",
    label: "Deep dive",
    subs: [
      { id: "heart", label: "Heart" },
      { id: "nervous", label: "Nervous System" },
      { id: "lungs", label: "Lungs" },
      { id: "respiratory", label: "Respiratory Function" },
      { id: "body-composition", label: "Body Composition" },
      { id: "metabolism", label: "Metabolism" },
      { id: "mitochondria", label: "Mitochondria" },
      { id: "energy-training", label: "Energy & Training" },
    ],
  },
  {
    // Note: the bio-age reduction card is a persistent header in this section
    // (rendered above the sub-step content), not a sub-step itself. The Figma
    // stepper shows 3 dots for Section 3.
    id: "programming",
    label: "Protocol",
    subs: [
      { id: "bio-optimization", label: "Bio-Optimization" },
      { id: "nutrition", label: "Nutrition" },
      { id: "training", label: "Training" },
    ],
  },
];

export const DEFAULT_SECTION: SectionId = "bio-age";
export const DEFAULT_SUB = "intro";

export const findSection = (id: string | null): Section | undefined =>
  SECTIONS.find((s) => s.id === id);

export const findSub = (
  section: Section | undefined,
  subId: string | null
): SubStep | undefined => section?.subs.find((s) => s.id === subId);
